import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../components/layout/Seo";
import { PageHero } from "../components/layout/PageHero";
import { Reveal } from "../components/motion/Reveal";
import { services } from "../content/services";

export default function ServicesIndex() {
  return (
    <>
      <Seo title="Technology Services in Kenya | TechCare Technologies" path="/services"
        description="Field services, digital infrastructure, hardware and software, AI, software engineering, managed services, cybersecurity and drone technology." />
      <PageHero eyebrow="Services & Solutions" lines={["Everything your", "technology needs."]} testid="services-hero"
        lead="Eight connected disciplines, delivered by one team. Choose a service to see what's involved." />
      <section className="bg-[#FAFAF9] py-20 text-stone-900 sm:py-28">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
          <ul className="border-t border-stone-300">
            {services.map((s, i) => (
              <Reveal as="li" key={s.slug} delay={(i % 3) * 0.05}>
                <Link to={`/services/${s.slug}`} data-testid={`services-list-${s.slug}`}
                  className="group grid grid-cols-12 items-center gap-4 border-b border-stone-300 py-8 transition-colors duration-300 hover:bg-white sm:py-10">
                  <span className="col-span-2 font-mono text-xs text-orange-700 sm:col-span-1">{s.index}</span>
                  <span className="col-span-10 font-display text-2xl tracking-tight transition-transform duration-500 group-hover:translate-x-2 sm:col-span-5 sm:text-4xl">{s.name}</span>
                  <span className="col-span-12 text-sm leading-relaxed text-stone-600 sm:col-span-4 sm:col-start-7">{s.short}</span>
                  <span className="col-span-12 hidden justify-end sm:col-span-1 sm:flex">
                    <span className="grid h-11 w-11 place-items-center rounded-full border border-stone-300 transition-[background-color,color,transform] duration-500 group-hover:rotate-45 group-hover:border-orange-600 group-hover:bg-orange-600 group-hover:text-white">
                      <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </span>
                </Link>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
